import { render, staticRenderFns } from "./ZuEmpty.vue?vue&type=template&id=817d868c&scoped=true"
import script from "./ZuEmpty.vue?vue&type=script&lang=js"
export * from "./ZuEmpty.vue?vue&type=script&lang=js"
import style0 from "./ZuEmpty.vue?vue&type=style&index=0&id=817d868c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "817d868c",
  null
  
)

export default component.exports